import { StatusColorType } from "@/components/atoms/Status/styled";

export const StatusColorMap = {
    inprogress: StatusColorType.Info,
    pending: StatusColorType.Error,
    processed: StatusColorType.Success,
};
